import React, { useContext, useState, useEffect, useRef } from "react";
import { Link, useNavigate } from 'react-router-dom';
import { f, database, storage, auth } from "../config";
import firebase from "firebase";
import db from "../config";
import { GlobalContext } from "../Globalstate";
import Swal from 'sweetalert2'
import emailjs from "emailjs-com";

function Investments() {
    const navigate = useNavigate();
    const [loading, setloading] = useState(false)
    const [adminusers, setadminusers] = useState([]);
    const [dataAvailable, setdataAvailable] = useState(false);
    const [lastdocument, setlastdocument] = useState(null)

    const [{ userdetails, loggedin, singleuser, singleuserkyc }, dispatch] = useContext(
        GlobalContext
    );

    function cleanDate(d) {
        var date = new Date(d);
        var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
        console.log("Date: " + date.getDate() +
            "/" + (months[date.getMonth() + 1]) +
            "/" + date.getFullYear() +
            " " + date.getHours() +
            ":" + date.getMinutes() +
            ":" + date.getSeconds());
        return `${date.getDate()} ${(months[date.getMonth()])} ${date.getFullYear()}  ${date.getHours()}  ${date.getMinutes()} ${date.getSeconds()}`
    }
    useEffect(() => {
        authcheck();
    }, []);
    const authcheck = async () => {
        setloading(true)
        const userdata = await f.auth().onAuthStateChanged(function (user) {
            if (user) {
                var userid = f.auth().currentUser;
                var userids = userid.uid;
                if (userids == "vKSvpr8AdihqQJ1KT3DCItILBqw2") {
                    adminfetchall();
                } else {
                    navigate("/login");
                }
                // console.log(adminusers);
                //  setloggedin(true);
            } else {
                navigate("/login");
            }
        });
    };

    const setSelecteduser = (data) => {
        dispatch({ type: "setsingleuser", snippet: data });
        //  setshowmodal(true)
        // navigate("/adminviews");
        // handleOpen()
    };

    // const adminfetchall = async () => {
    //     const data = await db
    //         .collection("investments").orderBy("timestamp", "desc")
    //         .get()
    //         .then((snapshot) => {
    //             snapshot.forEach((doc) => {
    //                 let User = doc.data();
    //                 User.id = doc.id;
    //                 adminusers.push(User);
    //             });
    //         });
    //     setloading(false)

    //     console.log(adminusers);
    //     const set = await setdataAvailable(true);
    // };
    const adminfetchall = async () => {
        const data = await db
            .collection("investments").orderBy("timestamp", "desc").limit(10)
            .get()
            .then((snapshot) => {
                snapshot.forEach((doc) => {
                    let User = doc.data();
                    User.id = doc.id;
                    adminusers.push(User);
                });
                console.log(snapshot.docs[snapshot.docs.length - 1])
                setlastdocument(snapshot.docs[snapshot.docs.length - 1])
            });

        setloading(false)

        console.log(adminusers);
        const set = await setdataAvailable(true);
    };

    const getNextDocuments = async () => {
        const ref = db.collection('investments').orderBy("timestamp", "desc").startAfter(lastdocument || 0).limit(10)
        const data = await ref.get();

        data.docs.forEach(doc => {
            let User = doc.data();
            User.id = doc.id;
            adminusers.push(User);
        })

        setlastdocument(data.docs[data.docs.length - 1])
        console.log(adminusers);
        setdataAvailable(true)

    }



    const updateUserBalanceandSub = (Uid, docid, subTodelete) => {
        console.log(docid)
        Swal.fire({
            title: 'Are you sure you want to stop this investment?',
            // text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, Stop it!'
        }).then((result) => {
            if (result.isConfirmed) {
                var washingtonRef = db.collection("users").doc(Uid);
                // var washingtonRef = await db.collection("users").doc(ordertoupdate.userID);
                // washingtonRef.update({
                //   openoders: firebase.firestore.FieldValue.arrayRemove(ordertoupdate.order)
                // }).then(function () {

                // })
                //   .catch(function (error) {
                //     console.log(error);
                //   });

                washingtonRef
                    .update({
                        currentSubscription: null,
                        currentSubscriptionArray: firebase.firestore.FieldValue.arrayRemove(subTodelete)
                    })
                    .then(function () {
                        Swal.fire(
                            'Terminated!',
                            'The investment has been stopped.',
                            'success'
                        )
                    })
                    .catch(function (error) {
                        // The document probably doesn't exist.
                        console.error("Error updating document: ", error);
                    });
                // fetchuserdata(userids);
                db.collection("investments").doc(docid).delete().then(() => {
                    console.log(docid)
                    console.log("Document successfully deleted!");
                    navigate("/");
                    Swal.fire(
                        'Deleted!',
                        'Your user has been deleted.',
                        'success'
                    )
                }).catch((error) => {
                    console.error("Error removing document: ", error);
                });

            }
        })

    };

    return (
        <div>
            <div className="wrapper">
                {/* Navbar */}
                <nav className="main-header navbar navbar-expand navbar-white navbar-light">
                    {/* Left navbar links */}
                    <ul className="navbar-nav">
                        <li className="nav-item">
                            <a className="nav-link" data-widget="pushmenu" href="#" role="button"><i className="fas fa-bars" /></a>
                        </li>
                    </ul>
                </nav>
                {/* /.navbar */}
                {/* Main Sidebar Container */}
                <aside className="main-sidebar sidebar-dark-primary elevation-4">
                    {/* Brand Logo */}
                    <a href="https://chainblockinvestment.com" className="brand-link">
                        <img src="https://chainblockinvestment.com/public/images/logos/logo.png" className="brand-image img-circle elevation-2" style={{ opacity: '.8' }} width={30} />
                        <span className="brand-text font-weight-light">Investment Admin</span>
                    </a>
                    {/* Sidebar */}
                    <div className="sidebar">
                        {/* Sidebar user (optional) */}
                        <div className="user-panel mt-3 pb-3 mb-3 d-flex">
                            <div className="image">
                                <img src="https://img.icons8.com/bubbles/1x/administrator-male.png" className="img-circle elevation-2" alt="User Image" />
                            </div>
                            <div className="info">
                                <a href="#" className="d-block">Darkest Mind</a>
                            </div>
                        </div>
                        {/* Sidebar Menu */}
                        <nav className="mt-2">
                            <ul className="nav nav-pills nav-sidebar flex-column" data-widget="treeview" role="menu" data-accordion="false">
                                {/* Add icons to the links using the .nav-icon class
           with font-awesome or any other icon font library */}
                                <li className="nav-item">
                                    <a href="/" className="nav-link">
                                        <i className="nav-icon fas fa-tachometer-alt" />
                                        <p>
                                            Dashboard
                                        </p>
                                    </a>
                                </li>
                                <li className="nav-item">
                                    <a href="/Settings" className="nav-link">
                                        <i className="nav-icon fas fa-tachometer-alt" />
                                        <p>
                                            Coin Deposit
                                        </p>
                                    </a>
                                </li>
                                <li className="nav-item">
                                    <a href="/users" className="nav-link">
                                        <i className="nav-icon fas fa-users" />
                                        <p>
                                            Manage Users
                                        </p>
                                    </a>
                                </li>
                                <li className="nav-item">
                                    <a href="/deposits" className="nav-link">
                                        <i className="nav-icon fas fa-donate" />
                                        <p>
                                            Manage Deposits
                                        </p>
                                    </a>
                                </li>
                                <li className="nav-item">
                                    <a href="/withdrawals" className="nav-link">
                                        <i className="nav-icon fas fa-hand-holding-usd" />
                                        <p>
                                            Manage Withdrawals
                                        </p>
                                    </a>
                                </li>

                                {/* <li className="nav-item has-treeview">
                                    <a href="#" className="nav-link">
                                        <i className="nav-icon fab fa-pagelines" />
                                        <p>
                                            Manage Minings
                                            <i className=" fas fa-angle-left right" />
                                        </p>
                                    </a>
                                    <ul className="nav nav-treeview" style={{ display: 'none' }}>
                                        <li className="nav-item super-admin" hidden>
                                            <a href="/admin/mining-plans" className="nav-link">
                                                <i className="nav-icon fab" />
                                                <p>
                                                    Plans
                                                </p>
                                            </a>
                                        </li>
                                        <li className="nav-item">
                                            <a href="/admin/all-minings" className="nav-link">
                                                <i className="nav-icon fab" />
                                                <p>
                                                    All Minings
                                                </p>
                                            </a>
                                        </li>
                                    </ul>
                                </li> */}
                                <li className="nav-item">
                                    <a href="/investments" className="nav-link">
                                        <i className="nav-icon fas fa-hand-holding-usd" />
                                        <p>
                                            Manage Investments
                                        </p>
                                    </a>
                                </li>


                                <li className="nav-item">
                                    <a href="/webmail" className="nav-link">
                                        <i className="nav-icon fas fa-envelope" />
                                        <p>
                                            Webmail
                                        </p>
                                    </a>
                                </li>
                                <li className="nav-item">
                                    <a href="/logout" className="nav-link">
                                        <i className="nav-icon fas fa-power-off" />
                                        <p>
                                            Logout
                                        </p>
                                    </a>
                                </li>
                            </ul>
                        </nav>
                        {/* /.sidebar-menu */}
                    </div>
                    {/* /.sidebar */}
                </aside>
                {/* Content Wrapper. Contains page content */}
                <div className="content-wrapper" style={{ minHeight: '777px' }}>
                    {/* Content Header (Page header) */}
                    <section className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-6">
                                    <h1>All Investment</h1>
                                </div>
                                <div className="col-sm-6">
                                    <ol className="breadcrumb float-sm-right">
                                        <li className="breadcrumb-item"><a href="https://chainblockinvestment.com/admin">Home</a></li>
                                        <li className="breadcrumb-item active">All Investment</li>
                                    </ol>
                                </div>
                            </div>
                        </div>{/* /.container-fluid */}
                    </section>
                    {/* Main content */}
                    <section className="content">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="row">
                                    <div className="col-md-12 d-flex justify-content-end">
                                        <button id="run_investment_job_button" className="btn btn-dark elevation-1 ml-3"><i className="fas fa-microchip" /> Run Investment Job</button>
                                    </div>
                                </div>
                                <hr />
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="card">
                                            <div className="card-body">
                                                <div className="row">
                                                    <table>
                                                        <tbody><tr>
                                                            <th className="pr-3">
                                                                PENDING:
                                                            </th>
                                                            <td>DAILY PAYOUT IN PROGRESS</td>
                                                        </tr>
                                                            <tr>
                                                                <th className="pr-3">
                                                                    PAID:
                                                                </th>
                                                                <td>DAILY PAYOUT SUCCESSFUL</td>
                                                            </tr>
                                                            <tr>
                                                                <th className="pr-2">
                                                                    COMPLETE
                                                                </th>
                                                                <td>MINING DURATION IS COMPLETE</td>
                                                            </tr>
                                                        </tbody></table>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="card">
                                            <div className="card-body p-0">
                                                <div className="table-responsive">
                                                    <div id="investment_table_wrapper" className="dataTables_wrapper dt-bootstrap4 no-footer"><div className="row"><div className="col-sm-12 col-md-6" /><div className="col-sm-12 col-md-6"><div id="investment_table_filter" className="dataTables_filter"><label>Search:<input type="search" className="form-control form-control-sm" placeholder aria-controls="investment_table" /></label></div></div></div><div className="row"><div className="col-sm-12"><table className="table table-striped dataTable no-footer" id="investment_table" data-page-length={50} role="grid" aria-describedby="investment_table_info">
                                                        <thead>
                                                            <tr role="row"><th style={{ width: '1%' }} className="sorting_disabled" rowSpan={1} colSpan={1}>
                                                                #
                                                            </th><th className="sorting_disabled" rowSpan={1} colSpan={1}>
                                                                    #
                                                                </th>
                                                                <th className="sorting_disabled" rowSpan={1} colSpan={1}>
                                                                    Name
                                                                </th><th className="sorting_disabled" rowSpan={1} colSpan={1}>
                                                                    Usd Equivalent
                                                                </th>
                                                                {/* <th className="sorting_disabled" rowSpan={1} colSpan={1}>
                                                                    Days Left
                                                                </th> */}
                                                                <th className="sorting_disabled" rowSpan={1} colSpan={1}>
                                                                    Status
                                                                </th><th className="sorting_disabled" rowSpan={1} colSpan={1}>
                                                                    Created Date/Time
                                                                </th>
                                                                {/* <th className="sorting_disabled" rowSpan={1} colSpan={1}>
                                                                    Last Activity Date
                                                                </th> */}
                                                                {/* <th className="text-center sorting_disabled" rowSpan={1} colSpan={1}>
                                                                    Auto Crediting
                                                                </th> */}
                                                                <th width="10%" className="text-center sorting_disabled" rowSpan={1} colSpan={1}>
                                                                    Action
                                                                </th></tr>
                                                        </thead>
                                                        <tbody>

                                                            {adminusers && adminusers.map((info, i) => {
                                                                return (
                                                                    <tr role="row" className="odd" key={info.userid}>
                                                                        <td>
                                                                            {i}
                                                                        </td>
                                                                        <td>
                                                                            <img src="https://img.icons8.com/bubbles/1x/administrator-male.png" className="img - fluid img - circle elevation - 2 bg - light" width="30px" alt="User Avatar" />
                                                                        </td>
                                                                        <td>
                                                                            {info.fullname}
                                                                        </td>
                                                                        <td>
                                                                            {info.subsription.amount}
                                                                        </td>
                                                                        {/* <td>
                                                                            {info.subsription.dueDate}
                                                                        </td> */}
                                                                        <td>
                                                                            {
                                                                                new Date().getTime() < info.subsription.dueDate ? (
                                                                                    <>
                                                                                        Pending
                                                                                    </>
                                                                                ) :
                                                                                    (
                                                                                        <>
                                                                                            Complete
                                                                                        </>
                                                                                    )
                                                                            }
                                                                        </td>
                                                                        <td>
                                                                            {cleanDate(info.subsription.dateSubscribed)}
                                                                        </td>
                                                                        {/* <td>
                                                                            1990-06-11
                                                                        </td> */}
                                                                        <td className="text-center">

                                                                            <button className="btn btn-danger btn-sm" onClick={() => { updateUserBalanceandSub(info.userid, info.id, info.subsription) }}>
                                                                                <i className="fas fa-trash">
                                                                                </i>
                                                                                Delete
                                                                            </button>
                                                                        </td>
                                                                    </tr>

                                                                )
                                                            })
                                                            }
                                                        </tbody>
                                                    </table></div>
                                                        <button className="btn btn-danger btn-sm" onClick={getNextDocuments} >
                                                            {/* <i className="fas fa-trash"> */}
                                                            {/* </i> */}
                                                            Load more
                                                        </button></div></div>
                                                </div>
                                            </div>
                                            {/* /.card-body */}
                                        </div>
                                    </div>
                                </div>
                                {/* /.box */}
                            </div>
                        </div>
                    </section>
                    {/* /.content */}
                </div>
                {/* /.content-wrapper */}
                <footer className="main-footer">
                    <div className="float-right d-none d-sm-block">
                        <b>Version</b> 3.0.4
                    </div>
                    <strong>Copyright © 2022 <a href="https://chainblockinvestment.com">Investment Admin</a>.</strong> All rights
                    reserved.
                </footer>
                <div id="sidebar-overlay" /></div>
            {/* ./wrapper */}
            {/* jQuery */}
            {/* Bootstrap 4 */}
            {/* AdminLTE App */}
            {/* Sweet Alert */}
            {/* Datatable */}
            {/* for ladda */}
        </div>
    )
}

export default Investments